import { UtilsService } from 'src/app/services/utils.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Test } from 'src/app/models/test.model';
import { TestService } from 'src/app/services/test.service';

@Component({
  selector: 'ct-ct-report',
  templateUrl: './ct-report.component.html',
  styleUrls: ['./ct-report.component.scss']
})
export class CtReportComponent implements OnInit {

  public test: Test;

  constructor(
    private testService: TestService,
    private activatedRoute: ActivatedRoute,
    public utilsService: UtilsService
  ) { }

  ngOnInit(): void {
    const token = this.activatedRoute.snapshot.paramMap.get('token');
    const jobtypeId = Number(this.activatedRoute.snapshot.queryParamMap.get('jobtypeId'));

    this.testService.getTestReportResults(token, jobtypeId).subscribe((test: Test) => {
      this.test = test;
    });
  }

}
